import { axiosInstance } from "@/config/apiClient";
import type { CicloFacturacion } from "../schemas";

export const redirectToStripeCheckout = async ({
	planId,
	ciclo,
}: {
	planId: number;
	ciclo: CicloFacturacion;
}): Promise<void> => {
	const response = await axiosInstance.post<{ url: string }>("/suscripcion/stripe/checkout", null, {
		params: { plan_id: planId, ciclo_facturacion: ciclo },
	});
	const { url } = response.data;
	if (!url) throw new Error("Stripe no devolvió URL de checkout");
	window.location.href = url;
};
